import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const titleMap = {
    www: "일신그룹",
    morning: "일신모닝택배",
    air: "일신항공해운",
    quick: "일신모닝퀵",
    express: "일신특송화물",
    ilshinconsole: "일신그룹관리자",
    console: "일신그룹관리자",
};

const currentType = "www";

const getTitle = (type: string) => titleMap[type as keyof typeof titleMap] || titleMap.morning;

type SeoProps = {
    type: string;
    pageTitle?: string;
};

export default function Seo({ type = "www", pageTitle }: SeoProps) {
    const location = useLocation();
    const defaultTitle = `${getTitle(currentType)}`;

    const [isDevelopment, setIsDevelopment] = useState<boolean>(false);
    const [title, setTitle] = useState(defaultTitle);

    useEffect(() => {
        const { host, port } = window.location;
        const parts = host.split(".");

        const isDevMode = parts.includes(`localhost:${port}`); // 개발모드
        const isDomainDevelop = parts.includes("likeweb"); // 개발운영모드

        const isDevelop = isDomainDevelop || isDevMode;

        setIsDevelopment(isDevelop);
    }, []);

    useEffect(() => {
        const prefix = isDevelopment ? "Dev " : "";

        // 메인페이지일때
        if (location.pathname === "/") {
            // 개발모드시 title 에 Dev 추가
            if (isDevelopment) {
                setTitle(`${prefix}${getTitle(currentType)}`);
                return;
            }
        } else {
            // 서브페이지
            const baseTitle = pageTitle ? `${pageTitle} - ${getTitle(currentType)}` : `${getTitle(currentType)}`;
            setTitle(`${prefix}${baseTitle}`);
        }
    }, [isDevelopment]);

    if (isDevelopment) {
        return (
            <Helmet>
                <title>{title}</title>
            </Helmet>
        );
    }
    return null;
}
